import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import 'AppSrc/core/style/components/form/form-base-components/select-coordinator-form.css';
import { connect } from 'react-redux';
import { nameIdPairShape } from 'AppSrc/core/data-structures/api-proptypes';
import { fetchCoordinatorGroupsForNetwork } from 'AppSrc/core/coordinators/coordinator-groups-actions';
import { getArraySortedByProperty } from 'AppSrc/core/utility-functions/sort-functions';
import { getCoordinatorGroupsForNetwork } from '../../../coordinators/coordinator-groups-state-selectors';

const SelectCoordinatorGroupDisplay = ({
  selectedGroupId,
  setGroup,
  coordinatorGroups,
  errorMessage,
  fetchGroups,
  fieldTitle,
  placeholder,
  crqType,
  isEmergency,
  isICM,
  isOlo,
}) => {
  // fetch the groups on first mount
  useEffect(fetchGroups, []);
  useEffect(() => {
    // Mainform create onload get the group with the correct id out and pass it to setGroup
    const group = coordinatorGroups.find((item) => item.id === selectedGroupId);
    // if (selectedGroupId !== null || group !== []) {
    //    setGroup(group);
    // }
    if (crqType === 'create-crq') {
      setGroup(group);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinatorGroups, selectedGroupId]);
  const touched = errorMessage ? true : false;
  const inlineErrors = errorMessage ? [errorMessage] : null;
  const aceL3Groups = coordinatorGroups.filter((value) => value.name.includes('ACE L3 - '));
  const finalGroups = (isEmergency && !isOlo) ? aceL3Groups : coordinatorGroups;
  const displayOptions = finalGroups.map((result) => ({
    text: result.name,
    value: result.id,
  }));
  return (
    <VFDropdownBase
      displayOptions={displayOptions}
      updateValue={(value) => {
        // get the group with the correct id out and pass it to setGroup
        const group = coordinatorGroups.find((item) => item.id === value);
        setGroup(group);
      }}
      fieldTitle={fieldTitle}
      placeholder={placeholder}
      name="selectGroup"
      value={selectedGroupId}
      touched={touched}
      inlineErrors={inlineErrors}
    />
  );
};

SelectCoordinatorGroupDisplay.propTypes = {
  selectedGroupId: PropTypes.string,
  setGroup: PropTypes.func,
  coordinatorGroups: PropTypes.arrayOf(nameIdPairShape),
  fetchGroups: PropTypes.func,
  errorMessage: PropTypes.string,
  fieldTitle: PropTypes.string,
  placeholder: PropTypes.string,
  crqType: PropTypes.string,
  isEmergency: PropTypes.bool,
  isICM: PropTypes.bool,
  isOlo: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const {
    network,
    isEmergency,
    isICM,
    isOlo,
  } = ownProps;
  const groupsUnsorted = getCoordinatorGroupsForNetwork({
    state,
    network,
  });
  const coordinatorGroups = getArraySortedByProperty(groupsUnsorted, 'name');
  return ({
    coordinatorGroups,
    isEmergency,
    isICM,
    isOlo,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchGroups() {
    const { network } = ownProps;
    dispatch(fetchCoordinatorGroupsForNetwork(network));
  },
});

const SelectCoordinatorGroup = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectCoordinatorGroupDisplay);

export { SelectCoordinatorGroup };

